import React, { FC } from "react";
import { Col, Row } from "reactstrap";
import { useFormikContext } from "formik";

import { RadioGroup } from "components/common/Form/RadioGroup";
import { TCartFormInitialValues } from "core/models/order.model";
import { PaymentType, PaymentTypeEnum } from "core/enum/payment-type.enum";
import {
  shipmentMethodData,
  ShipmentMethodEnum,
} from "core/enum/shipment-method.enum";
import { AddressForm } from "./AddressForm";

const FormFields: FC = () => {
  const { values, setFieldValue } = useFormikContext<TCartFormInitialValues>();

  const paymentTypeData = [
    PaymentType[PaymentTypeEnum.Online],
    PaymentType[PaymentTypeEnum.POS],
  ].map(({ value, description }) => ({
    value,
    label: description,
  }));

  const handleShipmentMethodChange = () => {
    setFieldValue("province", null);
    setFieldValue("county", null);
    setFieldValue("city", null);
    setFieldValue("rural", null);
    setFieldValue("village", null);
    setFieldValue("postalCode", "");
    setFieldValue("address", "");
  };

  //------------------------------------------------------------- Render --------------------------------------------

  return (
    <Row>
      <Col xs="12">
        <RadioGroup
          name="paymentType"
          label="روش پرداخت"
          significant
          options={paymentTypeData}
        />
      </Col>
      <Col xs="12">
        <RadioGroup
          name="shipmentMethod"
          label="روش ارسال"
          significant
          options={shipmentMethodData}
          onChange={handleShipmentMethodChange}
        />
      </Col>
      <Col xs="12">
        <hr />
      </Col>
      {values.shipmentMethod?.value === ShipmentMethodEnum.Post && (
        <AddressForm />
      )}
    </Row>
  );
};

export { FormFields };
